import React from "react";

import { Icon, Stack, Text } from "@chakra-ui/react";
import {
  MdDashboard,
  MdAreaChart,
  MdAccountBalanceWallet,
  MdLock,
  MdOutlineDataset,
  MdPayments,
  MdArrowBackIosNew,
  MdArrowBack
} from "react-icons/md";

import MainDashboard from "views/admin/default";
import Transactions from "views/admin/transactions";
import BalanceCheck from "views/admin/balancecheck";
import SignInCentered from "views/auth/signIn";
import ClientMgt from "views/admin/clientmgt";
import { UserManagement } from "views/admin/usermgt";
import { TopUpHistory } from "views/admin/topuphistory";
import { ReportMgt } from "views/admin/reportmgt";
import { RiUserSettingsLine } from "react-icons/ri";
import { IoIosPeople } from "react-icons/io";
import Report from "views/admin/report";
import { Link } from "react-router-dom";

/* let _role = '';
const clientInfo = sessionStorage.getItem('clientInfo');
if (clientInfo) {
  const { role } = JSON.parse(clientInfo);
  _role = role;
}
console.log(_role);
 */
const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdDashboard} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
    hidden: false,
    adminOnly: false
  },
  {
    name: "Transactions",
    layout: "/admin",
    path: "/transactions",
    icon: (
      <Icon
        as={MdAreaChart}
        width='20px'
        height='20px'
        color='inherit'
      />
    ),
    component: Transactions,
    secondary: true,
    hidden: false,
    adminOnly: false
  },
  {
    name: "Balance Check",
    layout: "/admin",
    icon: <Icon as={MdAccountBalanceWallet} width='20px' height='20px' color='inherit' />,
    path: "/balance-check",
    component: BalanceCheck,
    hidden: false,
    adminOnly: false
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: SignInCentered,
    hidden: true,
    adminOnly: false
  },
  {
    name: "Client Management",
    layout: "/admin",
    path: "/clientmgt",
    icon: <Icon as={IoIosPeople} width='20px' height='20px' color='inherit' />,
    component: ClientMgt,
    hidden: false,
    adminOnly: true
  },
  {
    name: "User Management",
    layout: "/admin",
    path: "/usermgt",
    icon: <Icon as={RiUserSettingsLine} width='20px' height='20px' color='inherit' />,
    component: UserManagement,
    hidden: false,
    adminOnly: true
  },
  {
    name: "Top-up History",
    layout: "/admin",
    path: "/topuphist",
    icon: <Icon as={MdPayments} width='20px' height='20px' color='inherit' />,
    component: TopUpHistory,
    hidden: false,
    adminOnly: null,
  },
  {
    name: "Report Management",
    layout: "/admin",
    path: "/reportmgt",
    icon: <Icon as={MdOutlineDataset} width='20px' height='20px' color='inherit' />,
    component: ReportMgt,
    hidden: false,
    adminOnly: true
  },
  {
    name: <Stack direction={'row'}><Link to={'/admin/reportmgt'}><MdArrowBack color="#0C7FE9" /></Link><Text pt='5px'>Client Report</Text></Stack>,
    layout: "/admin",
    path: "/clientreport",
    icon: <Icon as={MdOutlineDataset} width='20px' height='20px' color='inherit' />,
    component: Report,
    hidden: true,
    adminOnly: true
  }
]

export default routes;
